import { documentIsDefined } from 'src/helpers/document-helper';

import { userHasConsentedToCookieCategoryWithKey } from './consent-cookie';

export type Cookie = {
  key: string;
  getValue: () => string | undefined;
  isSet: () => boolean;
  trySetForSessionAtBasePath: (value: string) => void;
  trySetForSessionAtCurrentPath: (value: string) => void;
};

const canSetCookie = (cookieCategory: string): boolean =>
  documentIsDefined() && userHasConsentedToCookieCategoryWithKey(cookieCategory);

export const getCookieWithKey = (key: string, cookieCategory: string): Cookie => ({
  key: key,
  getValue: () => getCookieValueForKey(key),
  isSet: () => isCookieSetForKey(key),
  trySetForSessionAtBasePath: (value) => trySetCookieForSession(key, value, cookieCategory, '/'),
  trySetForSessionAtCurrentPath: (value) => trySetCookieForSession(key, value, cookieCategory),
});

const getCookieValueForKey = (key: string): string | undefined => {
  if (documentIsDefined()) {
    const value = '; ' + document.cookie;
    const parts = value.split('; ' + key + '=');
    if (parts.length === 2) {
      const encodedValue = parts.pop()!.split(';').shift();
      return !!encodedValue ? decodeURIComponent(encodedValue) : encodedValue;
    }
  }
};

const isCookieSetForKey = (key: string): boolean => !!getCookieValueForKey(key);

const trySetCookieForSession = (
  key: string,
  value: string,
  cookieCategory: string,
  path?: string
): void => {
  const pathIfSet = path ? `;path=${path}` : '';
  if (canSetCookie(cookieCategory)) {
    document.cookie = `${key}=${encodeURIComponent(value)};secure${pathIfSet}`;
  }
};
